module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "men"
  }, [_c('div', {
    staticClass: "classify-topBar"
  }, [_c('div', {
    staticClass: "classify-topNav"
  }, [_c('div', {
    staticClass: "classify-topNav-left"
  }, [_c('div', {
    staticClass: "classify-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "classify-topNav-right"
  }, [_c('div', {
    staticClass: "classify-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "classify-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "classify-container"
  }, [_c('ul', _vm._l((_vm.catalogList), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/classifydetails/' + item.id + '&' + item.catalog,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(item.catalog))])], 1)
  }))]), _vm._v(" "), _c('classify-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify-titleBox"
  }, [_c('span', {
    staticClass: "classify-title"
  }, [_vm._v("男生专区")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-b5801f78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/men/index.vue
// module id = 194
// module chunks = 1